import { h } from 'preact';

export default function LineChartIcon() {
  return <svg viewBox="0 0 107.14 98.21">
    <path
      d="m106.03,88.17H10.04V1.12c0-.62-.5-1.11-1.12-1.12H1.12C.5,0,0,.5,0,1.12v95.98c0,.62.5,1.11,1.12,1.12h104.91c.61,0,1.12-.5,1.12-1.12v-7.81c0-.61-.5-1.12-1.12-1.12Zm-81.22-21.53c.44.43,1.14.43,1.58,0l19.29-19.2,17.8,17.91c.44.43,1.14.43,1.58,0l38.42-38.41c.43-.44.43-1.14,0-1.58l-5.53-5.53c-.44-.43-1.14-.43-1.58,0l-32.09,32.07-17.77-17.88c-.44-.43-1.14-.43-1.58,0l-25.64,25.49c-.43.44-.43,1.14,0,1.58l5.51,5.54h0Z"/>
  </svg>;
}
